import {
  SET_SCHEMA,
  SET_AXG_SCHEMA,
} from '../action-types'

const initialState = {
  schema    : {},
}

export default function AXGSchema(state=initialState, action) {
  switch (action.type) {
    case SET_SCHEMA:
      // TODO: if action.options.isNew then set default in AXGView?
      // or centralize view id to AXGView?
      return {
        ...state,
        schema: action.options.schema,
      }
    case SET_AXG_SCHEMA:
      // TODO: if action.options.isNew then set default in AXGView?
      // or centralize view id to AXGView?
      return action.schema
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/axg-schema.js